import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Element, ItemCollectibleVariant } from '@outdoria/types';
import { fetcher } from '../utils';
import {
  ADMIN_COLLECTIBLE_VARIANT_ALL,
  ADMIN_COLLECTIBLE_VARIANT_CREATE,
  COLLECTIBLE_VARIANT,
  ITEM,
} from '../queryKeys';

type Data = {
  variant: Omit<ItemCollectibleVariant, 'item_collectible_variant_id'>;
  elements: Element['element_id'][];
};
export const useAdminCreateCollectibleVariant = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({
    variant,
    elements,
  }: Data): Promise<{ item_collectible_variant_id: string | null }> => {
    const response = await fetcher(`/v2/admin/items/collectibles/variant`, {
      method: 'POST',
      body: JSON.stringify({ ...variant, elements }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 201)
      throw new Error((await response.json()).error ?? 'Did not work!');

    queryClient.invalidateQueries({ queryKey: ADMIN_COLLECTIBLE_VARIANT_ALL });
    queryClient.invalidateQueries({
      queryKey: COLLECTIBLE_VARIANT,
      exact: false,
    });
    queryClient.invalidateQueries({ queryKey: ITEM, exact: false });

    const res = await response.json();
    return res?.[0] ?? { item_collectible_variant_id: null };
  };

  const { data, mutate, error, status, isPending, isSuccess, isError } =
    useMutation({
      mutationKey: ADMIN_COLLECTIBLE_VARIANT_CREATE,
      mutationFn,
    });

  return { data, mutate, error, status, isPending, isSuccess, isError };
};
